<template>
  <div
    ref="storePicker"
    class="store-picker"
  >
    <div
      class="store-picker__circle"
      :class="store ? '' : 'store-picker__circle-no-store'"
    >
      <store-profile-logo
        :has-store="!!store"
        :store-profile="store ? store.storeProfile : 0"
      />
    </div>
    <div
      v-if="!renderStore"
      class="store-picker__store-search"
    >
      <search-wrapper
        @search="getStores"
      />
      <div
        v-if="showModal && hasStores"
        class="modal-wrapper"
      />
      <select-store-modal
        v-if="showModal && hasStores"
        v-model="showModal"
        :home-delivery="storesHomeDelivery"
        :pickup="storesPickup"
      />

      <div
        v-if="isSearching"
        class="store-picker__loader"
      >
        <ica-spinner />
      </div>
      <div
        v-if="!isSearching && hasSearched && !hasStores"
        class="no-stores-result"
      >
        <p>
          Tyvärr kunde vi inte hitta någon butik som levererar matkassen och matchar din sökning.
        </p>
      </div>
    </div>
    <div
      v-else
    >
      <store-info
        v-if="store"
        @changeStore="clearSelectedStore"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import '#/Illustrative/Location'
import '#/Delivery/CollectinStore'
import '#/Delivery/HomeDelivery'
import '#/Controls/Check'
import '#/Logos/ICA'
import '#/Logos/ICA-Nara'
import '#/Logos/ICA-Supermarket'
import '#/Logos/ICA-Kvantum'
import '#/Logos/ICA-Maxi-Stormarknad'
import { mapMutations, mapState } from 'vuex'
import SelectStoreModal from './subcomponents/selectStoreModal'
import { IcaSpinner } from '~/@ica/ica-molecules-vue/src/components'
import StoreInfo from "@/vue/components/groceryBagComponents/StoreInfo.vue"
import searchWrapper from './subcomponents/searchWrapper'
import storeProfileLogo from  "@/vue/components/groceryBagComponents/StoreProfileLogo.vue"

export default {
  name: 'StorePicker',
  components: {
    'select-store-modal': SelectStoreModal,
    'ica-spinner': IcaSpinner,
    'store-info':StoreInfo, 
    'search-wrapper': searchWrapper,
    'store-profile-logo': storeProfileLogo,
  },
  data () {
    return {
      postalAdress: '',
      storesHomeDelivery: null,
      storesPickup: null,
      selectedStore: {},
      showModal: false,
      renderStore: null,
      isSearching: false,
      hasSearched: false,
      }
  },
  computed: {
    ...mapState(['store', 'storePickerKey', 'selectedDeliveryMethod']),
    hasStores () {
      return (this.storesHomeDelivery != null
        && this.storesHomeDelivery.length > 0)
        || (this.storesPickup != null && this.storesPickup.length > 0)
    }
  },
  watch: {
    storePickerKey () {
      this.$refs.storePicker.scrollIntoView({
        behavior: 'smooth'
      })
      //Focus input element after scroll
      setTimeout(() => {
        const input = document.getElementById("search-input-field")
        if(input) {
          input.focus()
        }
      }, 1000)
    },
    store (newStore) {
      this.renderStore = newStore
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      const params = new URLSearchParams(window.location.search)
      const bmsId = params.get('store')

      if (bmsId) {
        this.getStore(bmsId)
      } else if (this.store) {
        this.renderStore = this.store
      }
      if (!this.store && this.selectedDeliveryMethod) {
        this.clearSelectedStore()
      }
    })
  },
  methods: {
    ...mapMutations(['CLEAR_STORE', 'CLEAR_DELIVERY_METHOD', 'SET_DELIVERY_METHOD', 'SET_STORE', 'SET_STORE_SEARCH_QUERY', 'RESET_SHOW_STORE_PICKER']),
    clearSelectedStore () {
      this.storesHomeDelivery = null
      this.storesPickup = null
      this.showModal = false
      this.hasSearched = false
      this.CLEAR_STORE()
      this.CLEAR_DELIVERY_METHOD()
    },
    getStores (query) {
      this.SET_STORE_SEARCH_QUERY(query)
      this.clearSelectedStore()
      this.isSearching = true
      axios
        .get(`${this.$root.envConfig.baseUrl}/api/grocerybag/stores?query=${query}`)
        .then(
          data => this.loadStores(data.data),
          (this.showModal = true)
        )
        .catch(err => console.log(err))
        .finally(() => {
          this.isSearching = false
          this.hasSearched = true
        })
    },
    getStore (storeId) {
      axios.get(`/api/grocerybag/stores/bms/${storeId}`)
        .then(data => this.setStore(data.data.store))
        .catch(err => console.log(err))
    },
    loadStores (data) {
      this.storesHomeDelivery = data.homeDelivery
      this.storesPickup = data.pickup
    },
    setStore (store) {
      this.$store.dispatch('setGrocerybagStore',  {
        grocerybagStore: store , deliveryMethod: 0 
      })
      this.$store.dispatch('setGlobalStore', store)
    },
    translateStoreType (storeType) {
      let val = ''
      switch(storeType) {
        case 0: val = 'ICA'
        break
        case 1: val = 'ICA-Nara'
        break
        case 2: val = 'ICA-Supermarket'
        break
        case 3: val = 'ICA-Kvantum'
        break
        case 4: val = 'ICA-Maxi-Stormarknad'
        break
      }
      return val
    },
  }
}
</script>

<style lang="scss">
.store-picker {
  background: $color-white;
  border-radius: 2rem;
  box-shadow: $box-shadow-primary;
  padding: 1.5rem;
  position: relative;
  text-align: center;

  @include media-breakpoint-up(lg) {
    margin-top: 5rem;
  }

  .no-stores-result {
    margin: 0 3em;
  }

  &__circle {
    padding: 0.5rem;
    max-width: 4rem;
    max-height: 4rem;
    background: white;
    border-radius: 50%;
    position: absolute;
    width: 100%;
    box-shadow: 0 0.25rem 0.5rem 0 rgb(249, 245, 245);
    top: 3.5rem;

    @include media-breakpoint-up(md) {
      padding: 1.25rem;
      max-width: 5.5rem;
      max-height: 5.5rem;
      top: 0%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__circle-no-store {
    position: absolute;
    top: 0%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__store-search {
    padding: 2rem 0 1.5rem 0;
  }

  &__loader {
    margin-top: 2rem;
  }
}
</style>
